/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTokenUserNestedUserGroup
 */
export interface UserTokenUserNestedUserGroup {
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNestedUserGroup
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenUserNestedUserGroup
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof UserTokenUserNestedUserGroup
     */
    client: number;
}

export function UserTokenUserNestedUserGroupFromJSON(json: any): UserTokenUserNestedUserGroup {
    return UserTokenUserNestedUserGroupFromJSONTyped(json, false);
}

export function UserTokenUserNestedUserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokenUserNestedUserGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': json['label'],
        'client': json['client'],
    };
}

export function UserTokenUserNestedUserGroupToJSON(value?: UserTokenUserNestedUserGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'client': value.client,
    };
}


